import React, { useContext, useEffect, useState } from 'react';
import { styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Indicators } from '../components/Dashboard/Indicators';
import { SalesTable } from '../components/Table/SalesTable';
import { Message } from '../components/Dashboard/Message';
import { CollectionGraph } from '../components/Dashboard/CollectionGraph';
import { getBaskets } from '../services/cloudFirestore';
import { UserContext } from '../providers/UserProvider';
import { Paniers } from '../models/Paniers';
import { StyledColumnBox, StyledDashboardHeading } from '../theme/StyledElements';
import { useMountedRef } from '../hooks/useMountedRef';

const StyledBox = styled(StyledColumnBox)(() => ({
    alignItems: 'center',
    marginBottom: '100px'
}));

export function Dashboard(): React.ReactElement {
    const { t } = useTranslation();
    const mounted = useMountedRef();
    const user = useContext(UserContext);
    const [paniersList, setPaniersList] = useState<Paniers[]>([]);

    useEffect(() => {
        if (user && user.idProducteur && mounted.current) {
            getBaskets(user.idProducteur).then((data) => {
                setPaniersList(data);
            });
        }
    }, []);

    return (
        <StyledBox sx={{ justifyContent: 'center' }}>
            <StyledDashboardHeading variant="h3" sx={{ margin: '40px 0px 20px -690px' }}>
                {t('myKeyIndicators')}
            </StyledDashboardHeading>
            <Indicators paniersList={paniersList} />
            <StyledDashboardHeading variant="h3" sx={{ margin: '40px 0px 20px -590px' }}>
                {t('breakdownOfCollectionsPerSecond')}
            </StyledDashboardHeading>
            <CollectionGraph />
            <SalesTable />
            <Message />
        </StyledBox>
    );
}
